<h1 mat-dialog-title data-cy="ktcfdcfd_h1_1">Spalten anzeigen</h1>
<div mat-dialog-content>
    <ul style="list-style-type: none; padding: 0">
        <ng-container *ngFor="let m of data?.cols; let i = index">
            <li *ngIf="m?.aktiv">
                <mat-checkbox
                    [checked]="m?.sichtbar > 0"
                    [attr.data-cy]="'ktcfdcfd_mat-checkbox_' + i"
                    (change)="change(m, $event)"
                    >{{ m?.titel }}</mat-checkbox
                >
            </li>
        </ng-container>
    </ul>
</div>
<div mat-dialog-actions align="end">
    <button mat-button (click)="onCancelClick()" data-cy="ktcfdcfd_button_1">Abbrechen</button>
    <button
        mat-flat-button
        [disabled]="checkDisable() && isSaving"
        color="accent"
        (click)="save()"
        data-cy="ktcfdcfd_button_2"
        >Anwenden
    </button>
</div>
